export default __webpack_public_path__ + "static/media/menu_currentsystemreport.8658d1bf.svg";